export default __webpack_public_path__ + "static/media/slide-2.6776e561.jpg";